import Aura from '@primevue/themes/aura';
import type { PrimeVueConfiguration } from 'primevue/config';

/** Shared by the portal and the standalone visual-test gallery. */
export const primeVueConfig: PrimeVueConfiguration = {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            // The theme store stamps this class on <html> (ITDEVELOP-2615).
            darkModeSelector: '.dark',
            cssLayer: 'primevue, app-styles',
        },
    },
};
